import React, { useEffect, useState } from "react";
import Modal from "../modal/Modal";
import PropTypes from "prop-types";

import "./BenchmarkUploadModal.css";
import { FileWithSaveButton } from "../tender-price-indexing/currency-exchange/CurrencyExchangeUpdate";
import { useBenchmarkWithRows } from "../../api/benchmarking/BenchmarkingAPI";
import Spinner from "../common/Spinner";

import { FileTray } from "../tender-price-indexing/currency-exchange/CurrencyExchange.components";

import {
  deleteBenchmarkKeyDoc,
  getKeyDocs,
} from "./BenchmarkKeyDocs.functions";
import "./BenchmarkKeyDocs.css";
import PDFViewer from "../pdf/PDFViewer";
import { tranStr } from "../../utils/translation";
import isEmpty from "../../validation/is-empty";

/// props validation | SQ(javascript:S6774)
BenchmarkKeyDocs.propTypes = {
  benchmarkId: PropTypes.string,
  isViewOnly: PropTypes.bool,
};

export default function BenchmarkKeyDocs(props) {
  const [modal, setModal] = useState(false);
  const [error, setError] = useState({});

  const { benchmarkId } = props;
  const { isViewOnly } = props;

  useEffect(() => {
    setError({});
  }, [modal]);

  const tableRow = [];
  const { benchmarkWithRows } = useBenchmarkWithRows(benchmarkId);

  if (benchmarkWithRows?.loading) {
    return <Spinner width={"150px"} />;
  }

  if (isViewOnly && isEmpty(benchmarkWithRows.data[0]?.keyDocuments)) {
    return (
      <div className="no-data-available">
        <i className="fas fa-thumbs-down" /> No Associated Key Documents
        available
      </div>
    );
  }

  benchmarkWithRows.data[0]?.keyDocuments?.forEach((cell) => {
    tableRow.push(
      <div>
        <div className="general-row-container">{cell.fileName}</div>
        <PDFViewer
          documentId={cell.documentId}
          deleteButton={
            !isViewOnly && (
              <DeleteKeyDocButton
                documentId={cell.documentId}
                benchmarkId={benchmarkId}
                benchmarkWithRows={benchmarkWithRows}
              />
            )
          }
        />
      </div>
    );
  });

  return (
    <div className="bm-key-docs-container">
      {!isViewOnly && (
        <div className="bm-upload-button-container">
          <Modal
            // Modal Props
            title={"Upload Benchmark"}
            Component={KeyDocUpload}
            modal={modal}
            setModal={setModal}
            // Component Props
            setShow={setModal}
            setError={setError}
            error={error}
            benchmarkId={benchmarkId}
            dmsToken={props.dmsToken}
            benchmarkWithRows={benchmarkWithRows}
            {...props}
          />
          <button
            id="upload-benchmark-key-docs-button"
            className="general-upload-button"
            onClick={() => {
              setModal(true);
            }}
          >
            Upload
          </button>
        </div>
      )}
      <div className="bm-key-docs-table">{tableRow}</div>
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
KeyDocUpload.propTypes = {
  setModal: PropTypes.func,
  error: PropTypes.object,
  setError: PropTypes.func,
  benchmarkId: PropTypes.string,
  benchmarkWithRows: PropTypes.object,
};
export function KeyDocUpload(props) {
  const { setModal, error, setError, benchmarkId, benchmarkWithRows } = props;

  const [file, setFile] = useState([]); // file to upload

  return (
    <div className="location-factors-upload-modal">
      <div className="general-row-container-double">
        <FileTray file={file} />
      </div>
      <FileWithSaveButton
        uploadDataFunction={getKeyDocs}
        error={error}
        setError={setError}
        setFile={setFile}
        data={{
          benchmarkId: benchmarkId,
          setError: setError,
          setModal: setModal,
          file: file[0],
          benchmarkWithRows: benchmarkWithRows,
        }}
      />
    </div>
  );
}

DeleteKeyDocButton.propTypes = {
  documentId: PropTypes.string,
  benchmarkId: PropTypes.string,
  benchmarkWithRows: PropTypes.object,
};

export function DeleteKeyDocButton(props) {
  const { documentId } = props;
  const { benchmarkId, benchmarkWithRows } = props;
  const [isDeleting, setIsDeleting] = useState(false);

  if (isDeleting) {
    return <Spinner width={"20px"} />;
  }

  return (
    <div>
      <button
        id="key-docs-delete-button"
        className="pdf-delete-button"
        onClick={async () => {
          const confirm = window.confirm(
            `Confirm delete this PDF? This cannot be undone.`
          );

          if (!confirm) {
            return;
          }
          setIsDeleting(true);
          await deleteBenchmarkKeyDoc(
            documentId,
            benchmarkId,
            benchmarkWithRows,
            setIsDeleting
          );
        }}
      >
        {tranStr("Delete")}
      </button>
    </div>
  );
}
